import React from 'react'
import {
  Create,
  TextInput,
  useTranslate,
  SimpleForm,
  required,
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { Grid } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'

export const BillingCreate = (props) => {
  const translate = useTranslate()
  return (
    <Create {...props} redirect='list' actions={null}>
      <CardCommon title={translate('ra.entity.billing')} actions={null}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.address')} required>
              <TextInput source='address' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.region')} required>
              <TextInput source='region' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.email')} required>
              <TextInput source='email' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.type_responsible')} required>
              <TextInput source='type_responsible' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_type')} required>
              <TextInput source='document_type' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_number')} required>
              <TextInput source='document_number' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.phone_number')} required>
              <TextInput source='phone_number' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
